import React, { useState, useEffect } from "react";
import { Card } from "flowbite-react";
import clsx from "clsx";

import ApiService from "../../../services/api.service";

import Helper from "../../../common/helper";
import Global from "../../../common/global";
// import Spinner from '../../../common/spinner';
// import ErrorComponent from '../../../components/UI/error';
import ErrorComponent from "../../errors/error-box";

export default function LimePay({
  languages,
  member,
  transactionId,
  locationData,
  total,
  goNextStep,
  localStorageDatas,
  memberId,
  price_level_text,
}) {
  const LimepayCheckout = window.LimepayCheckout;

  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  // console.log("total", total);

  //const mainStripePromise = null;

  useEffect(() => {
    if (
      locationData.PaymentMethod.LimePay &&
      locationData.PaymentMethod.LimePay.Enabled
    ) {
      triggerLimePayPromise(
        transactionId,
        locationData.PaymentMethod.AsiaPay.PaymentSName
      );
    }
  }, []);

  async function triggerLimePayPromise(transactionId, paymentSName) {
    LimepayCheckout.init({
      publicKey: locationData.PaymentMethod.LimePay.PublicKey,
      email: member.email, // optional
      hidePayLaterOption: false /* optional (default false),
            can pass (true or false), it will show/hide the BNPL option */,
      paymentToken: function (token) {
        /* Once the checkout is complete this function will be called.
            Use the `token` on your server to complete the transaction. */
        limePaySubmitCallback(token, transactionId);
      },
    });
    LimepayCheckout.render({
      elementId: "limepay-cont",
      currency: locationData.currency,
      amount: total * 100, // should be in cents (integer)
      paymentType: "paycard" /* Optional (default "paycard"),
            selected payment option ("paycard" or "payplan") */,
      showPayNow: true /* Optional,
            enables Pay Now button for pay by card option */,
      showPayPlanSubmit: true /* Optional,
            enables Submit Payment Plan button for split payments option */,
    });
    LimepayCheckout.errorHandler(function (err) {
      // Handle errors
    });
    LimepayCheckout.eventHandler(function (event) {
      // Handle events
    });
  }

  function limePaySubmitCallback(token, transactionId) {
    LimepayCheckout.hide();
    //create LimePay data (billing, shipping, name, items, amount, currency, ap_transaction_id)
    let limepayData = buildLimepayData(transactionId);
    var errorMessage = "";

    //call API limePayCreateOrder()
    // ApiService.limePayCreateOrder(limepayData).then((createOrderResult) => {

    //     console.log('limepay createOrderResult', createOrderResult)

    //     let paymentDependencyParams = {
    //         "id": createOrderResult.id,
    //         "ap_transaction_id": transactionId,
    //         "paymentToken": token,
    //         "PaymentSName": locationData.PaymentMethod.LimePay.PaymentSName,
    //         //"partner_info": Helper.isQbr ? "QBR" : ""
    //         "partner_info": ""
    //     };
    //     // if(!createOrderResult.message === "Unauthorized")
    //     //call API limePayCreatePayment()
    //     ApiService.limePayCreatePayment(paymentDependencyParams).then((createPaymentResult) => {

    //         console.log('limepay createPaymentResult', createPaymentResult)

    //         if(createPaymentResult.errorMessage)
    //         // if(!createPaymentResult.message === "Unauthorized")
    //         goNextStep(transactionId, null, "LimePay")
    //     }).catch((err) => {
    //         console.error("Payment Error", err);
    //         LimepayCheckout.show();
    //     });
    // }).catch((err) => {
    //     console.error("Order Create Error", err);
    //     LimepayCheckout.show();
    // });

    ApiService.limePayCreateOrder(limepayData)
      .then((createOrderResult) => {
        // Check if createOrderResult contains an error or is not successful
        if (createOrderResult.errorMessage) {
          errorMessage =
            "ErrCode(1025): An error has occured, please try again.";
          throw new Error(createOrderResult.errorMessage); // Trigger catch block if there's an error
        }
        setIsLoaded(true);

        // console.log("limepay createOrderResult", createOrderResult);

        let paymentDependencyParams = {
          id: createOrderResult.id,
          ap_transaction_id: transactionId,
          paymentToken: token,
          PaymentSName: locationData.PaymentMethod.LimePay.PaymentSName,
          partner_info: "",
        };

        // Proceed to call limePayCreatePayment only if createOrderResult is successful
        return ApiService.limePayCreatePayment(paymentDependencyParams);
      })
      .then((createPaymentResult) => {
        // Check if createPaymentResult contains an error
        if (createPaymentResult.errorMessage) {
          errorMessage =
            "ErrCode(1026): An error has occured, please try again.";
          throw new Error(createPaymentResult.errorMessage); // Trigger catch block if there's an error
        }

        // console.log("limepay createPaymentResult", createPaymentResult);

        // Proceed to the next step
        setIsLoaded(false);
        goNextStep(transactionId, null, "LimePay");
      })
      .catch((err) => {
        setError(errorMessage);
        console.log("err", err);
        // Handle any errors from both createOrder and createPayment
        console.error("Error occurred", err);
        LimepayCheckout.show(); // Show checkout on error
      });
  }

  var buildLimepayData = function (transactionId) {
    var limepayData = {
      ap_transaction_id: transactionId,
      subsidiary: locationData.subsidiary,
      language: "en-au",
      //"pricelevel": (URL_PARAMS.pricelevel || LOCATION_DATA.defaultPriceLevel),
      pricelevel: price_level_text,
      member_id: memberId,
    };

    return limepayData;
  };

  return (
    <>
      <div id="limepay-cont"></div>
      {/* {isLoaded && 
            <div class="flex content-center justify-center">
                <Spinner />
            </div>
        } */}
      {error && (
        <div class="mt-5">
          <ErrorComponent errorMessage={error} languages={languages} />
        </div>
      )}
    </>
  );
}
